import { render } from "./CTA.vue?vue&type=template&id=696f2338&ts=true"
import script from "./CTA.vue?vue&type=script&lang=ts"
export * from "./CTA.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__